import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Struttura } from '../types/Struttura';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SicotService } from '../sicot.service';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { SceltaPdeStrutturaBodyReq } from '../types/SceltaPdeStrutturaBodyReq';
import { CotEsitoUvm } from '../types/CotEsitoUvm';
@Component({
  selector: 'app-scelta-pde-struttura',
  imports: [
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule, MatOptionModule,
    MatDatepickerModule, MatIconModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    CommonModule,
    MatDividerModule
  ],
  templateUrl: './scelta-pde-struttura.component.html',
  styleUrl: './scelta-pde-struttura.component.css'
})
export class SceltaPdeStrutturaComponent implements OnInit {

  @Input() idRichiesta: any;

  @Output() valueChanged = new EventEmitter<any>();

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);
  @ViewChild('stepper') stepper?: MatStepper;

  API_ENDPOINT_COT_SERVICE = this.sicotservice.API_ENDPOINT_COT_SERVICE;

  dataSource: any;
  esitoUvm: any | undefined;
  uvmPresente: boolean = false;
  tipoStrutturaSan: string = '8';
  tipoStrutturaSanDescr: string = 'STRUTTURA SANITARIA E SOCIOSANITARIA RESID. E SEMIRESID';


  ngOnInit(): void {
    this.scaricoUno();


  }


  scaricoUno(): void {
    const id = this.idRichiesta;

    this.http.get<CotEsitoUvm>(this.API_ENDPOINT_COT_SERVICE + `/esito-uvm/${id}`).subscribe({
      next: (data: CotEsitoUvm) => {
        this.esitoUvm = data;
        this.scaricoDue();
        this.uvmPresente = true;
      },
      error: (error) => {
        this.esitoUvm = {
          interventi: []
        };
        this.uvmPresente = false;
        this.scaricoDue();
      }
    });
  }


  settingProposto: string | null = null;

  scaricoDue(): void {
    this.http.get<any>(this.API_ENDPOINT_COT_SERVICE + "/richieste/" + this.idRichiesta).subscribe({
      next: (data) => {
        this.settingProposto = data.settingProposto ?? null;
        if (data.settingProposto === 'ASSISTENZA RESIDENZIALE') {
          this.tipoStrutturaSanDescr = 'STRUTTURA SANITARIA E SOCIOSANITARIA RESID. E SEMIRESID';
          this.tipoStrutturaSan = '8'
        }

        if (data.settingProposto === 'ASSISTENZA HOSPICE') {
          this.tipoStrutturaSan = '28'
          this.tipoStrutturaSanDescr = 'HOSPICE';
        }


        if (data.settingProposto === 'ASSISTENZA SEMIRESIDENZIALE') {
          this.tipoStrutturaSanDescr = 'STRUTTURA SANITARIA E SOCIOSANITARIA RESID. E SEMIRESID';
          this.tipoStrutturaSan = '8'
        }

        if (data.settingProposto === 'RICOVERO PROGRAMMATO') {
          this.tipoStrutturaSanDescr = 'REPARTO OSPEDALIERO';
          this.tipoStrutturaSan = '5'
        }


        this.scaricoTre();
      },
      error: (error) => {

      }
    });
  }

  scaricoTre(): void {
    let c = this.esitoUvm?.descProfiloCura;
    if (c === undefined) {
      c = '';
    }

    if (this.uvmPresente == true) {
      this.tipoStrutturaSan = '';
    }

    if (this.settingProposto === 'ASSISTENZA RESIDENZIALE') {
      this.sicotservice.getStrutture().subscribe({
        next: (data) => {
          const rows = (data || []).map((s: any) => ({ ...s, strutture: [s] }));
          this.dataSource = new MatTableDataSource<any[]>(rows);
          this.dataSource.paginator = this.paginator;
        },
        error: () => {}
      });
      return;
    }

    this.http.get<any[]>(this.API_ENDPOINT_COT_SERVICE + "/strutture-pde?richiesta=" + this.idRichiesta + "&prestazione=" + c + "&tipo=" + this.tipoStrutturaSan).subscribe({
      next: (data) => {
        this.dataSource = new MatTableDataSource<any[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      error: () => {}
    });
  }

  displayedColumns: string[] = ['id', 'distretto', 'tipoStruttura', 'codice', 'descrizione', 'tipologiaGiuridica', 'codNazionaleAsl', 'tipoResidenza', 'tipoAssistenza'];


  linear: boolean = true;

  strutture: Struttura[] = [];

  formStepUno: FormGroup = this.fb.group({
    struttura: [''],
    pde: [''],
  });

  formStepDue: FormGroup = this.fb.group({
    inizioIntervento: [''],
    fineIntervento: [''],
    dataInizioIntervento: [''],
    dataFineIntervento: [''],
    note: ['']
  });

  formStepTre: FormGroup = this.fb.group({});



  constructor(
    private fb: FormBuilder, private http: HttpClient, private sicotservice: SicotService, private cdr: ChangeDetectorRef
  ) { }

  pulisci(stepper: MatStepper) {
    this.formStepUno.reset();
    this.formStepDue.reset();
    this.formStepTre.reset();
    stepper.reset();
  }

  conferma() {

    let sceltePDEStrBodyRequests = [];
    let interventi = this.esitoUvm?.interventi || [];

    for (let intervento of interventi) {

      let sceltaPDEStrBodyReq = new SceltaPdeStrutturaBodyReq();
      sceltaPDEStrBodyReq.richiestaId = this.idRichiesta;
      sceltaPDEStrBodyReq.strutturaId = this.strutturaSelezionata.id;
      sceltaPDEStrBodyReq.operatoreId = null;
      sceltaPDEStrBodyReq.codiceQualificaOperatore = intervento.codTipoErogatore?.toString();
      sceltaPDEStrBodyReq.frequenza = intervento.tipoFrequenza?.toString() + " " + intervento.numeroAccessiPrevisti;
      sceltaPDEStrBodyReq.tipoInterventoId = null;
      sceltaPDEStrBodyReq.attivita = intervento.attivita;
      sceltaPDEStrBodyReq.dataInizio = this.formStepDue.get('dataInizioIntervento')?.value
      sceltaPDEStrBodyReq.dataFine = this.formStepDue.get('dataFineIntervento')?.value
      sceltaPDEStrBodyReq.noteAggiuntive = this.formStepDue.get('note')?.value
      sceltePDEStrBodyRequests.push(sceltaPDEStrBodyReq);

    }

    if(interventi.length === 0){
      let sceltaPDEStrBodyReq = new SceltaPdeStrutturaBodyReq();
      sceltaPDEStrBodyReq.richiestaId = this.idRichiesta;
      sceltaPDEStrBodyReq.strutturaId = this.strutturaSelezionata.id;
      sceltaPDEStrBodyReq.operatoreId = null;
      sceltaPDEStrBodyReq.codiceQualificaOperatore = '';
      sceltaPDEStrBodyReq.frequenza = '';
      sceltaPDEStrBodyReq.tipoInterventoId = null;
      sceltaPDEStrBodyReq.attivita = [];
      sceltaPDEStrBodyReq.dataInizio = this.formStepDue.get('dataInizioIntervento')?.value
      sceltaPDEStrBodyReq.dataFine = this.formStepDue.get('dataFineIntervento')?.value
      sceltaPDEStrBodyReq.noteAggiuntive = this.formStepDue.get('note')?.value
      sceltePDEStrBodyRequests.push(sceltaPDEStrBodyReq);
    }

    console.log("sceltePDEStrBodyRequests", sceltePDEStrBodyRequests);


    this.sicotservice.salvaInterventiPaziente(sceltePDEStrBodyRequests)
      .subscribe({
        next: (response: any) => {
          //this.saveIntervento = response;

          this.valueChanged.emit(true);
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });

    //

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  strutturaSelezionata: any;

  onStepSubmit(strutturaSelezionata: any): void {
    this.strutturaSelezionata = strutturaSelezionata;
    this.formStepUno.patchValue({ struttura: strutturaSelezionata?.id ?? '', pde: strutturaSelezionata?.codice ?? '' });
    this.formStepUno.markAsTouched();
    setTimeout(() => {
      this.stepper?.next();
      this.cdr.detectChanges();
    }, 0);
  }
  tipoInterventoSelezionato: any = null;
  caricaIntervento(e: any) {
    console.log(e);
    this.tipoInterventoSelezionato = e.tipoInterventoId;
    this.esitoUvm?.interventi?.push(e);
  }




}
